<div class="alert alert-warning alert-dismissible fade show" role="alert">
  <div [innerHTML]="addAlertMessage | translate"></div>
  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
